/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CloseCircleOutlined,
  MoreOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  Dropdown,
  Image,
  Progress,
  Row,
  Select,
  Tag,
} from "antd";
import {
  AmountIcon,
  DeleteIcon,
  GreenCheckIcon,
  PenIcon,
  SelectArrow,
  StarFilledIcon,
  TickIcon,
} from "../../../../../atoms/CustomIcons";
import SubContractorIcon from "../../../../../atoms/CustomIcons/SubContractor";

export default function Dashboard(props: any) {
  // const [contactDetails, setContactDetails] = useState({
  //   starred: false,
  //   signing: false,
  //   billing: false,
  //   subContractor: false,
  // });

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<CloseCircleOutlined />}
        >
          Remove from property
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<DeleteIcon />}
        >
          Delete
        </Button>
      ),
    },
  ];
  console.log("props.stats", props?.data?.stats);
  return (
    <div className="profileWrapper">
      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Stats</h3>
          <div>
            <Select
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Filters"
              defaultValue="Filters"
              popupMatchSelectWidth={false}
              style={{ borderRadius: "10px" }}
              options={[
                {
                  value: "past_month",
                  label: "Past month",
                },
                {
                  value: "past_6_months",
                  label: "Past 6 months",
                },
                {
                  value: "past_quarter",
                  label: "Past quarter",
                },
                {
                  value: "past_year",
                  label: "Past year",
                },
              ]}
            />
          </div>
        </div>
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Total revenue</div>
                <div className="info">
                  ${props?.data?.stats?.totalRevenue?.toLocaleString()}
                </div>
              </div>
              {/* <Progress percent={70} success={{ percent: 45, strokeColor: "#6454f4" }} showInfo={false} type="line" strokeColor="#44a6f1" trailColor="#e88a56" size={["100%", 12]} /> */}
              <Progress
                percent={100}
                success={{
                  percent:
                    +`${props?.data?.stats?.revenueBreakdown?.[0]?.percentage}`,
                  strokeColor: `${props?.data?.stats?.revenueBreakdown?.[0]?.barColor}`,
                }}
                showInfo={false}
                type="line"
                size={["100%", 12]}
              />
              <div className="progressInfo">
                {props?.data?.stats?.revenueBreakdown?.map((_item: any) => (
                  <div className="infoWrapper">
                    <Badge color={_item.barColor} text={_item.text} />
                    <div className="infoValue">
                      ${_item.value?.toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Gross margin & profit</div>
                <div className="info">
                  {props?.data?.stats.grossMargin.overall}%
                </div>
              </div>

              <Progress
                percent={
                  props?.data?.stats.grossMargin.breakdown[1]
                    ? props?.data?.stats.grossMargin.breakdown[0].value +
                      props?.data?.stats.grossMargin.breakdown[1].value
                    : 100
                } //middle line
                success={{
                  percent: +`${
                    props?.data?.stats.grossMargin.breakdown[1]
                      ? props?.data?.stats.grossMargin.breakdown[0].value
                      : 100
                  }`, //First Line
                  strokeColor: `${props?.data?.stats.grossMargin.breakdown[0].barColor}`,
                }}
                showInfo={false}
                type="line"
                strokeColor={
                  props?.data?.stats.grossMargin.breakdown[1]
                    ? props?.data?.stats.grossMargin.breakdown[1].barColor
                    : "#E04949"
                }
                trailColor={
                  props?.data?.stats.grossMargin.breakdown[2]
                    ? props?.data?.stats.grossMargin.breakdown[2].barColor
                    : "#E04949"
                }
                size={["100%", 12]}
              />
              <div className="progressInfo">
                {props?.data?.stats.grossMargin.breakdown.map((_item: any) => (
                  <div className="infoWrapper">
                    <Badge color={_item.barColor} text={_item.text} />
                    <div className="infoValue">{_item.value}%</div>
                  </div>
                ))}
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Win ratio</div>
                <div className="info">{props?.data?.stats.winRatio.value}%</div>
              </div>

              <Progress
                percent={100}
                success={{
                  percent: props?.data?.stats.winRatio.value,
                  strokeColor: "#00A07D",
                }}
                showInfo={false}
                type="line"
                strokeColor="#E04949"
                size={["100%", 12]}
              />
              <div className="progressInfo">
                <div className="infoWrapper">
                  <Badge color="#00A07D" text="Wins:" />
                  <div className="infoValue">
                    {props?.data?.stats.winRatio.wins}
                  </div>
                </div>
                <div className="infoWrapper">
                  <Badge color="#E04949" text="Losses:" />
                  <div className="infoValue">
                    {props?.data?.stats.winRatio.losses}
                  </div>
                </div>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard threeValues">
              <div className="profileProgressHeader">
                <div className="label">Accounts receivable</div>
                <div className="info">
                  $
                  {props?.data?.stats.accountsReceivable.total?.toLocaleString()}
                </div>
              </div>
              {/* <Progress percent={100} success={{ percent: +`${props?.data?.stats.grossMargin.breakdown.percentage}`, strokeColor: `${props?.data?.stats.grossMargin.breakdown.barColor}` }} showInfo={false} type="line" size={["100%", 12]} /> */}

              <Progress
                percent={
                  (props?.data?.stats.accountsReceivable.breakdown[0].value /
                    props?.data?.stats.accountsReceivable.total) *
                    100 +
                  (props?.data?.stats.accountsReceivable.breakdown[1].value /
                    props?.data?.stats.accountsReceivable.total) *
                    100
                } //middle line
                success={{
                  percent: +`${
                    (props?.data?.stats.accountsReceivable.breakdown[0].value /
                      props?.data?.stats.accountsReceivable.total) *
                    100
                  }`, //First Line
                  strokeColor: `${props?.data?.stats.accountsReceivable.breakdown[0].barColor}`,
                }}
                showInfo={false}
                type="line"
                strokeColor={
                  props?.data?.stats.accountsReceivable.breakdown[1].barColor
                }
                trailColor={
                  props?.data?.stats.accountsReceivable.breakdown[2].barColor
                }
                size={["100%", 12]}
              />
              <div className="progressInfo">
                {props?.data?.stats.accountsReceivable.breakdown.map(
                  (_item: any) => (
                    <div className="infoWrapper">
                      <Badge color={_item.barColor} text={_item.text} />
                      <div className="infoValue">
                        ${_item.value?.toLocaleString()}
                      </div>
                    </div>
                  )
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </Card>

      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Contacts</h3>
          <Button icon={<PlusOutlined />} className="outlined-btn">
            Add contact
          </Button>
        </div>

        <Row gutter={[0, 4]}>
          {props.data.contacts?.map((x: any) => {
            return (
              <Col span={24}>
                <Card className="contactCard">
                  <div className="contactCardLeft">
                    <div className="namePosition">
                      <h4>{x.name}</h4>
                      <Tag className={x.color}>{x.title}</Tag>
                    </div>
                    <div className="infoText">
                      <div className="labelText">Phone:</div>
                      <div className="valueText">
                        {x.phone} <GreenCheckIcon />
                      </div>
                    </div>

                    <div className="infoText">
                      <div className="labelText">Email:</div>
                      <div className="valueText">{x.email}</div>
                    </div>

                    <div className="infoText">
                      <div className="labelText">Roles:</div>
                      <div className="valueText">
                        <div className="profileActionBtns">
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     starred: !prev.starred,
                            //   }))
                            // }
                            className={
                              x.is_starred ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <StarFilledIcon />
                          </Button>
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     signing: !prev.signing,
                            //   }))
                            // }
                            className={
                              x.is_signing ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <PenIcon />
                          </Button>
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     billing: !prev.billing,
                            //   }))
                            // }
                            className={
                              x.is_billing ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <AmountIcon />
                          </Button>
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     subContractor: !prev.subContractor,
                            //   }))
                            // }
                            className={
                              x.is_contractor ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <SubContractorIcon />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdownContact">
                    <Dropdown
                      menu={{ items }}
                      trigger={["click"]}
                      placement="bottomRight"
                      className="actionButton"
                    >
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onKeyDown={(e) => e.stopPropagation()}
                        style={{
                          padding: "6px",
                          height: "auto",
                        }}
                        className="only_icon"
                        icon={<MoreOutlined />}
                      />
                    </Dropdown>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
}
